
<h3 class="bdo-container re-mb-30">{{title}}</h3>
<div class="bdo-container--single">
  @if (state === LoadingState.LOADING) {
    <div class="bdo-tile bdo-loading__wrapper" [class.bdo-loading__wrapper--height]="state === LoadingState.LOADING">
      <bdo-loading></bdo-loading>
    </div>
  }
  @if (state === LoadingState.IDLE) {
    <div class="re-copytext">
      {{ 'emailVerification.success' | translate}}
    </div>
  }
  @if (state === LoadingState.ERROR) {
    <bdo-info-teaser
      [title]="'emailVerification.title.error' | translate"
      [iconSrc]="'offer.status.notAvailable.iconSrc' | translate"
      [hasButton]="false">
      <div [innerHTML]="'emailVerification.error' | translate"></div>
    </bdo-info-teaser>
  }

  <div class="re-mt-30">
    <bdo-text-link-icon
      [iconPosition]="'left'"
      [linkText]="((loginService.isLoggedIn$ | async) ? 'personaldata.linkTo' : 'general.navigation.backToLogin' ) | translate"
      [routerUrl]="(loginService.isLoggedIn$ | async) ? '/daten' : '/login' "
    ></bdo-text-link-icon>
  </div>


</div>

